import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminReports() {
  const { user } = useAuth();
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/reports").then(({ data }) => setR(data)).catch(() => {}); }, []);
  if (!r) return <p className="font-heading text-2xl text-ink/40">Loading…</p>;

  const money = [];
  if (r.total_sales !== undefined) money.push(["Gross Sales", `$${r.total_sales.toFixed(2)}`]);
  if (user.role === "super_admin" && r.agency_earnings !== undefined) money.push(["Agency Earnings", `$${r.agency_earnings.toFixed(2)}`]);
  if (r.net_revenue !== undefined) money.push([user.role === "super_admin" ? "Net Store Payout" : "Net Revenue", `$${r.net_revenue.toFixed(2)}`]);

  return (
    <div data-testid="admin-reports">
      <h1 className="font-heading text-4xl tracking-tight mb-2">Reports</h1>
      <p className="font-body text-sm text-ink/60 mb-8">Money breakdown and inventory intelligence.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {money.map(([l, v], i) => (
          <div key={i} className="adm-card"><p className="adm-label">{l}</p><p className="font-heading text-3xl">{v}</p></div>
        ))}
        <div className="adm-card"><p className="adm-label">Paid Orders</p><p className="font-heading text-3xl">{r.orders_paid}</p></div>
        <div className="adm-card"><p className="adm-label">Total Orders</p><p className="font-heading text-3xl">{r.orders_total}</p></div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="adm-card">
          <h3 className="font-heading text-xl mb-4">Best Sellers</h3>
          {r.top_products.length === 0 ? <p className="text-sm text-ink/50">No sales yet.</p> :
            <ul className="space-y-2">{r.top_products.map((p, i) => (
              <li key={i} className="flex justify-between font-body text-sm border-b border-ink/5 pb-2"><span>{i + 1}. {p.title}</span><span className="text-ink/60">{p.sold} sold</span></li>
            ))}</ul>}
        </div>
        <div className="adm-card">
          <h3 className="font-heading text-xl mb-4">Low / Out of Stock</h3>
          {r.low_stock.length === 0 ? <p className="text-sm text-ink/50">All sizes healthy.</p> :
            <ul className="space-y-2">{r.low_stock.map((p, i) => (
              <li key={i} className="flex justify-between font-body text-sm border-b border-ink/5 pb-2"><span>{p.product} · {p.size}</span><span className={p.stock <= 0 ? "text-destructive" : "text-ink/60"}>{p.stock} left</span></li>
            ))}</ul>}
        </div>
      </div>
    </div>
  );
}
